import PropTypes from 'prop-types';
export const SEARCH_TYPE = PropTypes.oneOf([
    'address',
    'destination',
    'event',
    'venue',
    'city',
]);
